export default {
    MAPTILER_API_KEY: "757mHAscRUzjJNIAcCs7",
  };